import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { MARGIN } from '../../constants';
import { MarginQuery } from '../queries';

export class MarginCalculator extends Calculator {
  kpiType = MARGIN

  async calculateKPI() {
    const currentResponse = await this.executeUncubeQuery(MarginQuery, this.currentPeriod);
    const currentRawKpi = this.getMargin(currentResponse);
    let previousResponse = {};
    let props;
    if (this.previousPeriod) {
      previousResponse = await this.executeUncubeQuery(MarginQuery, this.previousPeriod);
      const previousRawKpi = this.getMargin(previousResponse);
      props = this.getData(currentRawKpi, previousRawKpi);
    } else props = this.getDataIfNoPreviousPeriod(currentRawKpi);
    return this.getModelToInstance(props);
  }

  getMargin(response) {
    return (response.data.result[0][0] - response.data.result[0][1]);
  }
}
